<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">Contact details</h4>
    <button mat-icon-button mat-dialog-close>
      <mat-icon fontIcon="close"></mat-icon>
    </button>
  </div>
  <form class="dialog__content" [formGroup]="form" (ngSubmit)="handleSubmit()">
    <mat-dialog-content>
      <div *comSpinner="isFetching; color: 'primary'; diameter: 30;">
        @if (!!form) {
          <section class="dialog__content__controls">
            @if (editMode) {
              <mat-form-field class="form-field--fill" subscriptSizing="dynamic">
                <mat-label>Status</mat-label>
                <input matInput formControlName="status" />
              </mat-form-field>

              <mat-checkbox formControlName="isPrimaryContact">
                Primary contact 
              </mat-checkbox>
            }

            <mat-form-field class="form-field--fill">
              <mat-label>First name</mat-label>
              <input matInput formControlName="contactFirstName" />
              <mat-error>Please enter contact's first name</mat-error>
            </mat-form-field>

            <mat-form-field class="form-field--fill">
              <mat-label>Last name</mat-label>
              <input matInput formControlName="contactLastName" />
              <mat-error>Please enter contact's last name</mat-error>
            </mat-form-field>

            <mat-form-field class="form-field--fill">
              <mat-label>Phone number</mat-label>
              <input matInput formControlName="phoneNumber" />
              <mat-error>Please enter contact's valid phone number</mat-error>
            </mat-form-field>

            <mat-form-field class="form-field--fill">
              <mat-label>Email address</mat-label>
              <input matInput formControlName="emailAddress" />
              <mat-error>Please enter contact's valid email address</mat-error>
            </mat-form-field>

            @if (addMode) {
              <mat-checkbox formControlName="isPrimaryContact" class="dialog__tooltip-checkbox">
                Primary contact
                <mat-icon
                  class="dialog__icon"
                  matTooltip="The Primary Contact will be used by ComReg for communicating updates to the SMS Sender ID Registry. The Primary Contact does not have any special rights at this time but may have in the future.">
                  info
                </mat-icon>
              </mat-checkbox>
            }
          </section>
        }
      </div>
    </mat-dialog-content>
    <mat-dialog-actions cdkFocusRegionstart>
      @if (editMode) {
        <button mat-raised-button class="button--secondary" [class.button--warning]="contactActive" type="button" (click)="handleToggleStatus()">
          {{ contactActive ? 'Deactivate' : 'Activate' }}
        </button>
        <button mat-raised-button class="button--secondary" [disabled]="contactPrimary" type="button" (click)="handleSetAsPrimary()">
          Set as primary
        </button>
        <button mat-raised-button [disabled]="!form.dirty || isSaving" type="submit">Edit</button>
      }

      @if (addMode) {
        <button mat-raised-button [disabled]="isSaving" class="button--secondary" type="button" mat-dialog-close>Cancel</button>
        <button mat-raised-button [disabled]="!form.dirty || isSaving" type="submit">Save</button>
      }
    </mat-dialog-actions>
  </form>
</div>
